import { Directive, EventEmitter, Input, Output } from '@angular/core';
import FieldsSettings from 'src/app/forms/fields/fields.settings';
import { CustomMarkerData } from 'src/app/interfaces/map.interface';
import { BucketTooltip } from '../map.interfaces';

@Directive()
export class MarkerInfoState {
  @Input({ required: true }) public isLoggedIn: boolean;
  @Input({ required: true }) public isAdminSession: boolean;

  @Input({ required: false }) public index = 0;
  @Input({ required: false }) public data: CustomMarkerData;
  @Input({ required: false }) public isActive: boolean;

  @Input({ required: false }) public tooltips: BucketTooltip[];
  @Input({ required: false }) public itemsKind: string;
  @Input({ required: false }) public itemsCount: number;

  @Output() public itemClicked: EventEmitter<void> = new EventEmitter<void>();

  public FieldsSettings: typeof FieldsSettings = FieldsSettings;
}
